import React, { useEffect, useState } from 'react';
import FindLangKey from 'Global/Functions/FindLangKey/FindLangKey';
import { fetchPageConfig } from '../adapaters/fetchPageConfig';

const useFetchPageConfig = () => {
  const title = FindLangKey(
    'get-new-turn-title-terms-condition'
  );
  const networkErrorMsg = FindLangKey(
    'general-public-alert-network-error'
  );

  const [pageConfig, getConfig] = useState(null);

  useEffect(() => {
    fetchPageConfig(getConfig, networkErrorMsg);
  }, []);

  return { title, pageConfig };
};

export default useFetchPageConfig;
